<template>
  <div class="boolean">
    <div class="stem">
      <span>{{ idx }}.</span>
      <span class="type">({{ checkType(question.type) }})</span>
      <span>{{ question.question }}</span>
      <span class="score">{{ question.score }}分</span>
    </div>
    <div class="options">
      <p class="answer">正确答案：{{ question.answerList[0] }}</p>
      <div class="o-left">
        <div
          class="one-option"
          v-for="item in question.optionList"
          :key="item.tag"
        >
          <p class="text">{{ item.tag }}. {{ item.option }}</p>
          <el-progress
            :stroke-width="10"
            :color="isCorrect(item.tag) ? 'teal' : '#f56c6c'"
            :percentage="item.rate || 0"
            :format="
              (percentage) => format(percentage, item.num || 0, item.rate || 0)
            "
          ></el-progress>
        </div>
      </div>
      <div class="o-right">
        <ve-pie
          v-if="showChart"
          :data="chartData"
          :extend="chartExtend"
        ></ve-pie>
      </div>
    </div>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";
export default {
  props: {
    question: Object,
    idx: Number,
  },
  data() {
    return {
      checkType,
      chartData: {
        columns: ["tag", "checked"],
        rows: [],
      },
      chartExtend: {
        series: {
          type: "pie",
          top: -35,
          height: 220,
        },
      },
      showChart: false,
    };
  },
  created() {
    this.chartData.rows = this.question.optionList;
  },
  mounted() {
    this.showChart = true;
  },
  watch: {
    question(val) {
      this.chartData.rows = val.optionList;
    },
  },
  methods: {
    format(percentage, num, rate) {
      return `${num}人 ${Number(rate.toFixed(2))}%`;
    },
    isCorrect(option) {
      return this.question.answerList.some((item) => {
        return item == option;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.boolean {
  text-align: left;
  .stem {
    padding: 20px 30px;
    border-bottom: solid 1px #ddd;
    .type {
      margin: 0 5px;
      color: #969696;
    }
    .score {
      margin-left: 10px;
      color: #969696;
      font-weight: bold;
    }
  }
  .options {
    padding: 20px 30px;
    .answer {
      margin-bottom: 20px;
      color: #1890ff;
    }
    .o-left {
      display: inline-block;
      width: 70%;
      vertical-align: top;
      ::v-deep .one-option {
        margin-bottom: 10px;
        .text {
          margin-bottom: 10px;
        }
        .el-progress-bar {
          width: 85%;
        }
      }
    }
    .o-right {
      display: inline-block;
      width: 30%;
      text-align: center;
      vertical-align: top;
    }
  }
}
</style>